import { useTranslate } from '@refinedev/core';
import { Tag } from 'antd';
import { EntitlementStatus } from '@/api/generated/schemas';

const statusColors: Record<EntitlementStatus, string> = {
  active: 'success',
  inactive: 'default',
};

interface EntitlementStatusTagProps {
  value?: EntitlementStatus | null;
}

export const EntitlementStatusTag = ({ value }: EntitlementStatusTagProps) => {
  const t = useTranslate();
  if (!value) return <>-</>;
  return (
    <Tag color={statusColors[value]}>
      {t(`monetization.entitlements.status.${value}`)}
    </Tag>
  );
};
